import {NgModule} from "@angular/core";
import {GruppeRedigerKomponentAvhengigheter} from "./komponenter/gruppe-rediger/gruppe-rediger";
import {GruppeVisDetaljerKomponentAvhengigheter} from "./komponenter/gruppe-vis-detaljer/gruppe-vis-detaljer";
import {ListGruppeBrukerMalKomponentAvhengigheter} from "./komponenter/list-gruppe-bruker-mal/list-gruppe-bruker-mal";
import {GruppeNyKomponentAvhengigheter} from "web-ng2/moduler/gruppe/komponenter/gruppe-ny/gruppe-ny";
import {GruppeInvitasjonKortKomponentAvhengigheter} from "web-ng2/moduler/gruppe/komponenter/gruppe-invitasjon-kort/gruppe-invitasjon-kort";
import {GruppeGodtaInvitasjonDialogKomponentAvhengigheter} from "web-ng2/moduler/gruppe/modale/gruppe-godta-invitasjon-dialog/gruppe-godta-invitasjon-dialog";
import {GrupperVisKomponentAvhengigheter} from "web-ng2/moduler/gruppe/komponenter/grupper-vis/grupper-vis";
import {SlettGruppeKomponentAvhengigheter} from "web-ng2/moduler/gruppe/komponenter/slett-gruppe/slett-gruppe";
import {GruppeMøteevalueringerKomponentAvhengigheter} from "web-ng2/moduler/gruppe/komponenter/gruppe-møteevalueringer/gruppe-møteevalueringer";
import {GruppeProtokollOppsettKomponentAvhengigheter} from "web-ng2/moduler/gruppe/komponenter/gruppe-protokoll-oppsett/gruppe-protokoll-oppsett";
import {GruppeSakstyperKomponentAvhengigheter} from "web-ng2/moduler/gruppe/komponenter/gruppe-sakstyper/gruppe-sakstyper";
import {GruppeSakstypeRedigerListeKomponentAvhengigheter} from "web-ng2/moduler/gruppe/komponenter/gruppe-sakstype-rediger-liste/gruppe-sakstype-rediger-liste";
import {GruppeRollerKomponentAvhengigheter} from "web-ng2/moduler/gruppe/komponenter/gruppe-roller/gruppe-roller";
import {GruppeRolleRedigerListeKomponentAvhengigheter} from "web-ng2/moduler/gruppe/komponenter/gruppe-rolle-rediger-liste/gruppe-rolle-rediger-liste";
import {GruppeTemaerKomponentAvhengigheter} from "web-ng2/moduler/gruppe/komponenter/gruppe-temaer/gruppe-temaer";
import {GruppeTemaRedigerListeKomponentAvhengigheter} from "web-ng2/moduler/gruppe/komponenter/gruppe-tema-rediger-liste/gruppe-tema-rediger-liste";
import {GruppeTillatteAutentiseringsmetoderAvhengigheter} from "web-ng2/moduler/gruppe/komponenter/gruppe-tillatte-autentiseringsmetoder/gruppe-tillatte-autentiseringsmetoder";

@NgModule({
    providers: [
        GrupperVisKomponentAvhengigheter,
        GruppeRedigerKomponentAvhengigheter,
        GruppeNyKomponentAvhengigheter,
        GruppeVisDetaljerKomponentAvhengigheter,
        GruppeInvitasjonKortKomponentAvhengigheter,
        GruppeGodtaInvitasjonDialogKomponentAvhengigheter,
        ListGruppeBrukerMalKomponentAvhengigheter,
        SlettGruppeKomponentAvhengigheter,
        GruppeMøteevalueringerKomponentAvhengigheter,
        GruppeProtokollOppsettKomponentAvhengigheter,
        GruppeSakstyperKomponentAvhengigheter,
        GruppeSakstypeRedigerListeKomponentAvhengigheter,
        GruppeRollerKomponentAvhengigheter,
        GruppeRolleRedigerListeKomponentAvhengigheter,
        GruppeTemaerKomponentAvhengigheter,
        GruppeTemaRedigerListeKomponentAvhengigheter,
        GruppeTillatteAutentiseringsmetoderAvhengigheter,
    ]
})
export class GruppeModul{

}
